<template>
  <div>
    <v-list v-if="!loading" two-line>
      <v-list-item v-if="value.length === 0">
        <v-list-item-content class="text-center">
          <i>Nenhum contato disponível</i>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-else
        v-for="(contato, i) in value"
        :key="`contato-${i}`"
        @click="$emit('select', contato)"
      >
        <list-item-contato :contato="contato" />
        <v-list-item-action v-if="editando">
          <v-btn
            v-if="!contato.novo && !contato.remover"
            icon
            color="error"
            @click.stop="$set(contato, 'remover', true)"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <v-btn
            v-else-if="contato.remover"
            icon
            color="error"
            @click.stop="contato.remover = false"
          >
            <v-icon>mdi-undo</v-icon>
          </v-btn>
          <v-btn v-else icon color="error" @click.stop="removerNovo(contato)">
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-skeleton-loader v-else type="list-item-two-line" />
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import ListItemContato from "./ListItemContato";
import { build } from "../../lib/masks";
export default {
  components: { ListItemContato },
  props: {
    value: Array,
    loading: Boolean,
    editando: Boolean,
  },
  computed: mapState({
    perms: (state) => state.usuarios.usuarioAtivo.permissoes,
  }),
  methods: {
    strTipo(tipo) {
      return this.$store.getters["contato/strTipo"](tipo);
    },
    principal(lista) {
      return this.$store.getters["contato/principal"](lista);
    },
    removerNovo(contato) {
      const contatos = _.clone(this.value);
      const idx = contatos.indexOf(contato);
      contatos.splice(idx, 1);
      this.$emit("input", contatos);
    },
    maskTelefone(val) {
      return build.phone(val);
    },
  },
};
</script>
